/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadTracesSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type UploadTracesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Encoding applied to the OTLP request body. Supported values are gzip and identity.
   */
  contentEncoding?: string | undefined;
};

/** @internal */
export type UploadTracesSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const UploadTracesSecurity$outboundSchema: z.ZodMiniType<
  UploadTracesSecurity$Outbound,
  UploadTracesSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadTracesSecurityToJSON(
  uploadTracesSecurity: UploadTracesSecurity,
): string {
  return JSON.stringify(
    UploadTracesSecurity$outboundSchema.parse(uploadTracesSecurity),
  );
}

/** @internal */
export type UploadTracesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Content-Encoding"?: string | undefined;
};

/** @internal */
export const UploadTracesRequest$outboundSchema: z.ZodMiniType<
  UploadTracesRequest$Outbound,
  UploadTracesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    contentEncoding: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      contentEncoding: "Content-Encoding",
    });
  }),
);

export function uploadTracesRequestToJSON(
  uploadTracesRequest: UploadTracesRequest,
): string {
  return JSON.stringify(
    UploadTracesRequest$outboundSchema.parse(uploadTracesRequest),
  );
}
